import React from 'react';

const EventCardSkeleton = () => {
  return (
    <div className="editorial-card overflow-hidden h-full animate-pulse">
      {/* Image Skeleton */}
      <div className="relative aspect-[4/3] bg-muted">
        {/* Date Badge Skeleton */}
        <div className="absolute top-4 left-4 bg-background/95 rounded-lg p-2 min-w-[60px]">
          <div className="h-3 bg-muted rounded mb-1"></div>
          <div className="h-5 bg-muted rounded"></div>
        </div>

        {/* Favorite Button Skeleton */}
        <div className="absolute top-4 right-4 w-10 h-10 bg-background/95 rounded-full"></div>

        {/* Category Badge Skeleton */}
        <div className="absolute bottom-4 left-4">
          <div className="h-6 w-20 bg-primary/20 rounded-full"></div>
        </div>
      </div>

      {/* Content Skeleton */}
      <div className="p-6">
        {/* Title Skeleton */}
        <div className="space-y-2 mb-4">
          <div className="h-6 bg-muted rounded w-3/4"></div>
          <div className="h-6 bg-muted rounded w-1/2"></div>
        </div>

        {/* Time and Location Skeleton */}
        <div className="space-y-2 mb-4">
          <div className="flex items-center">
            <div className="w-4 h-4 bg-muted rounded mr-2"></div>
            <div className="h-4 bg-muted rounded w-24"></div>
          </div>
          <div className="flex items-center">
            <div className="w-4 h-4 bg-muted rounded mr-2"></div>
            <div className="h-4 bg-muted rounded w-32"></div>
          </div>
        </div>

        {/* Organizer Skeleton */}
        <div className="flex items-center mb-4">
          <div className="w-8 h-8 bg-muted rounded-full mr-3"></div>
          <div className="space-y-1">
            <div className="h-4 bg-muted rounded w-24"></div>
            <div className="h-3 bg-muted rounded w-16"></div>
          </div>
        </div>

        {/* Pricing Tiers Skeleton */}
        <div className="mb-4">
          <div className="h-4 bg-muted rounded w-20 mb-2"></div>
          <div className="space-y-1">
            <div className="flex justify-between">
              <div className="h-3 bg-muted rounded w-16"></div>
              <div className="h-3 bg-muted rounded w-12"></div>
            </div>
            <div className="flex justify-between">
              <div className="h-3 bg-muted rounded w-20"></div>
              <div className="h-3 bg-muted rounded w-16"></div>
            </div>
          </div>
        </div>

        {/* Footer Skeleton */}
        <div className="flex items-center justify-between pt-4 border-t border-border">
          <div className="flex items-center">
            <div className="w-4 h-4 bg-muted rounded mr-1"></div>
            <div className="h-3 bg-muted rounded w-20"></div>
          </div>
          <div className="h-5 bg-muted rounded w-16"></div>
        </div>
      </div>
    </div>
  );
};

export default EventCardSkeleton;